module.exports = __webpack_public_path__ + "img/2.b8e07939.jpg";